module.exports = __webpack_public_path__ + "hyperion-v2-static/img/places_example.f7bf0888.png";